import api from "./api.js";

export default class PopupApi {
  static async createPopup(data) {
    return await api.post(`api/popup`, data);
  }

  static async getListPopup(params) {
    return await api.get(`api/popup`, params);
  }

  static async deletePopup(params) {
    return await api.del(`api/popup`, params);
  }

  static async getByIdPopup(popupId, params) {
    return await api.get(`api/popup/${popupId}`, params);
  }

  static async updatePopup(popupId, data) {
    return await api.patch(`api/popup/${popupId}`, data);
  }

  static async updateActivationPopup(popupId, data) {
    return await api.patch(`api/popup/activation/${popupId}`, data);
  }
}
